// extracted by mini-css-extract-plugin
export default {"main":"Doc_main__+NEEF"};